 
import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/admin/revenueAll';
const countriesUrl = base_url+'api/admin/esCountries';
const paymentTypeUrl = base_url+'api/admin/prPaymentType';

export const getpaymentType = async () => {
  const response = await api.get(paymentTypeUrl);
  return response.data.data;
};

export const getcountries = async () => {
  const response = await api.get(countriesUrl);
  return response.data.data;
};

export const getData = async () => {
  const response = await api.get(path);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};